module.exports = __webpack_public_path__ + "img/knf.5ca55b07.svg";